import { render, staticRenderFns } from "./IconTicketOutline.vue?vue&type=template&id=08f3fb7e"
import script from "./IconTicketOutline.vue?vue&type=script&lang=js"
export * from "./IconTicketOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports